import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PoiOrgService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getOrgBySiteUid(env: string, siteUid: string): Observable<RetailDataDealerInformation> {
    return this.http.get<RetailDataDealerInformation>(`${this.baseurlService.getBaseUrl()}/poi/organization/${env}/bySiteUid/${siteUid}`);
  }

  getOrgByDealerContext(env: string, dealerContext: string): Observable<RetailDataDealerInformation> {
    return this.http.get<RetailDataDealerInformation>(`${this.baseurlService.getBaseUrl()}/poi/organization/${env}/byDealerContext/${dealerContext}`);
  }
}

export interface RetailDataDealerInformation {
  dms: string;
  country: string;
  dealerContext: string;
  brandContext: string[];
  cross2Organisation?: {
    clusterSystem: string;
    clusterName: string;
    vpdId: string;
    dealerNumber: string;
    clientSystems: string[];
  };
  cross3Organisation?: {
    tenantGroupId: string;
    tenantGroupMatchCode: string;
    tenantId: string;
    legalCompanyId: string;
    siteId: string;
    workAreaId: string;
    stage: string;
    clientSystems: string[];
  };
  registeredAtTimestamp?: string;
}
